<div class="container-xl">
    <div class="row justify-content-between">
        <app-breadcrumb [crumbs]="crumbs" class="col"></app-breadcrumb>
        @if (form()?.get('id').value && (Features.CheckpointsDetailDelete | hasFeature)) {
            <button (click)="openDelete($event)" color="warning" mat-icon-button>
                <mat-icon fontIcon="fa-trash" fontSet="fas"></mat-icon>
            </button>
        }
    </div>

    @if (form() && values(); as v) {
        <div [formGroup]="form()" class="section-form">
            <div class="summary">
                <div class="summary-label">Samenvatting</div>
                <p>
                    @for (part of summary(); track $index) {
                        <span [class.value]="part.bold">{{ part.text }}</span>
                    }
                </p>
            </div>

            <section class="form-section">
                <div class="section-intro">
                    <div class="section-head">
                        <span class="section-icon"><i class="fa-regular fa-bullseye"></i></span>
                        <h2>Wat wordt gecontroleerd</h2>
                    </div>
                    <p>Welke URL, onder welk platform en in welke omgeving.</p>
                </div>
                <div class="section-fields">
                    <div class="field">
                        <label for="name">Naam</label>
                        <mat-form-field subscriptSizing="dynamic">
                            <input formControlName="name" id="name" matInput name="name" placeholder="Bijv. Backup-API health">
                        </mat-form-field>
                        <div class="field-help">Herkenbare naam in overzichten en meldingen.</div>
                    </div>
                    <div class="field">
                        <label>Platform</label>
                        <ng-select [items]="platforms()" [searchable]="true" bindLabel="name" bindValue="id" formControlName="platform_id">
                        </ng-select>
                        <div class="field-help">Platform waar deze check onder valt.</div>
                    </div>
                    <div class="field full">
                        <label for="url">URL</label>
                        <mat-form-field subscriptSizing="dynamic">
                            <input class="mono" formControlName="url" id="url" matInput name="url" placeholder="https://">
                        </mat-form-field>
                        <div class="field-help">Het adres dat periodiek wordt opgevraagd.</div>
                    </div>
                    <div class="field">
                        <label>Niveau</label>
                        <ng-select [searchable]="true" bindLabel="name" bindValue="id" formControlName="level">
                            <ng-option [value]="checkpointLevels.PRODUCTION">{{ checkpointLevels.PRODUCTION }}</ng-option>
                            <ng-option [value]="checkpointLevels.HEALTH">{{ checkpointLevels.HEALTH }}</ng-option>
                            <ng-option [value]="checkpointLevels.CHECK">{{ checkpointLevels.CHECK }}</ng-option>
                            <ng-option [value]="checkpointLevels.ACCEPTANCE">{{ checkpointLevels.ACCEPTANCE }}</ng-option>
                        </ng-select>
                        <div class="field-help">Bepaalt onder welk van de vier statusbolletjes in de navigatie deze check meetelt.</div>
                    </div>
                    <div class="field">
                        <label for="external_ip_allowed">Externe IP <span class="optional">· optioneel</span></label>
                        <mat-form-field subscriptSizing="dynamic">
                            <input class="mono" formControlName="external_ip_allowed" id="external_ip_allowed" matInput name="external_ip_allowed" placeholder="0.0.0.0">
                        </mat-form-field>
                        <div class="field-help">Gevuld = de check wordt niet zelf uitgevoerd. Resultaten komen alleen binnen via externe logging vanaf dit IP.</div>
                    </div>
                </div>
            </section>

            <section class="form-section">
                <div class="section-intro">
                    <div class="section-head">
                        <span class="section-icon"><i class="fa-regular fa-clock"></i></span>
                        <h2>Wanneer</h2>
                    </div>
                    <p>Hoe vaak de check draait en in welke periode.</p>
                </div>
                <div class="section-fields narrow">
                    <div class="field">
                        <label for="interval">Interval</label>
                        <mat-form-field subscriptSizing="dynamic">
                            <input class="mono" formControlName="interval" id="interval" matInput name="interval" type="number">
                            <span class="unit" matTextSuffix>ms</span>
                        </mat-form-field>
                        <div class="field-help">Elke <b>{{ v.interval | msReadable }}</b> wordt de URL opgevraagd.</div>
                    </div>
                    <div class="field">
                        <label for="start_date">Startdatum</label>
                        <mat-form-field subscriptSizing="dynamic">
                            <input (focus)="pickerStart.open()" [matDatepicker]="pickerStart" [min]="minDate" formControlName="start_date" id="start_date" matInput placeholder="Startdatum">
                            <mat-datepicker-toggle [for]="pickerStart" matSuffix></mat-datepicker-toggle>
                            <mat-datepicker #pickerStart></mat-datepicker>
                            <mat-error [control]="form().get('start_date')"></mat-error>
                        </mat-form-field>
                        <div class="field-help">Vanaf deze dag actief.</div>
                    </div>
                    <div class="field">
                        <label for="end_date">Einddatum <span class="optional">· optioneel</span></label>
                        <mat-form-field subscriptSizing="dynamic">
                            <input (focus)="pickerEnd.open()" [matDatepicker]="pickerEnd" [min]="minDate" formControlName="end_date" id="end_date" matInput placeholder="Einddatum">
                            <mat-datepicker-toggle [for]="pickerEnd" matSuffix></mat-datepicker-toggle>
                            <mat-datepicker #pickerEnd></mat-datepicker>
                            <mat-error [control]="form().get('end_date')"></mat-error>
                        </mat-form-field>
                        <div class="field-help">Leeg laten = blijft actief.</div>
                    </div>
                </div>
            </section>

            <section class="form-section">
                <div class="section-intro">
                    <div class="section-head">
                        <span class="section-icon"><i class="fa-regular fa-circle-check"></i></span>
                        <h2>Wanneer is het goed</h2>
                    </div>
                    <p>Aan welke voorwaarden de respons moet voldoen.</p>
                </div>
                <div class="section-fields narrow">
                    <div class="field">
                        <label for="valid_response_code">Valide statuscode</label>
                        <mat-form-field subscriptSizing="dynamic">
                            <input class="mono" formControlName="valid_response_code" id="valid_response_code" matInput name="valid_response_code">
                        </mat-form-field>
                        <div class="field-help">HTTP-code die als goed telt. Elke andere code geeft een error.</div>
                    </div>
                    <div class="field">
                        <label for="warning_response_code">Waarschuwings-statuscode <span class="optional">· optioneel</span></label>
                        <mat-form-field subscriptSizing="dynamic">
                            <input class="mono" formControlName="warning_response_code" id="warning_response_code" matInput name="warning_response_code" placeholder="Bijv. 301">
                        </mat-form-field>
                        <div class="field-help">Deze code geeft een waarschuwing in plaats van een error.</div>
                    </div>
                    <div class="field">
                        <label>SSL-certificaat controleren</label>
                        <ng-select [clearable]="false" [searchable]="false" bindLabel="name" bindValue="id" formControlName="validate_ssl">
                            <ng-option [value]="true">Ja</ng-option>
                            <ng-option [value]="false">Nee</ng-option>
                        </ng-select>
                        <div class="field-help">Bij Ja geeft een ongeldig of verlopen certificaat een error.</div>
                    </div>
                    <div class="field full">
                        <label for="valid_checksum">Checksum van de inhoud <span class="optional">· optioneel</span></label>
                        <mat-form-field subscriptSizing="dynamic">
                            <input class="mono" formControlName="valid_checksum" id="valid_checksum" matInput name="valid_checksum" placeholder="MD5-hash">
                        </mat-form-field>
                        <div class="field-help">MD5-hash van de verwachte inhoud. Komt de respons hier niet mee overeen, dan volgt een waarschuwing.</div>
                    </div>
                </div>
            </section>

            <section class="form-section">
                <div class="section-intro">
                    <div class="section-head">
                        <span class="section-icon"><i class="fa-regular fa-triangle-exclamation"></i></span>
                        <h2>Als het misgaat</h2>
                    </div>
                    <p>Hoe lang er gewacht wordt en hoe vaak opnieuw geprobeerd wordt na een error.</p>
                </div>
                <div class="section-fields narrow">
                    <div class="field">
                        <label for="timeout">Timeout</label>
                        <mat-form-field subscriptSizing="dynamic">
                            <input class="mono" formControlName="timeout" id="timeout" matInput name="timeout" type="number">
                            <span class="unit" matTextSuffix>ms</span>
                        </mat-form-field>
                        <div class="field-help">Geen antwoord binnen <b>{{ v.timeout | msReadable }}</b> = poging mislukt.</div>
                    </div>
                    <div class="field">
                        <label for="retries">Pogingen</label>
                        <mat-form-field subscriptSizing="dynamic">
                            <input class="mono" formControlName="retries" id="retries" matInput name="retries" type="number">
                        </mat-form-field>
                        <div class="field-help">Aantal extra pogingen na een error, voordat het gewone interval weer geldt.</div>
                    </div>
                    <div class="field">
                        <label for="retry_delay">Wachttijd tussen pogingen</label>
                        <mat-form-field subscriptSizing="dynamic">
                            <input class="mono" formControlName="retry_delay" id="retry_delay" matInput name="retry_delay" type="number">
                            <span class="unit" matTextSuffix>ms</span>
                        </mat-form-field>
                        <div class="field-help"><b>{{ v.retry_delay | msReadable }}</b> wachten voor de volgende poging.</div>
                    </div>
                    <div class="field">
                        <label>Respons altijd opslaan</label>
                        <ng-select [clearable]="false" [searchable]="false" bindLabel="name" bindValue="id" formControlName="save_contents_on_success">
                            <ng-option [value]="false">Nee</ng-option>
                            <ng-option [value]="true">Ja</ng-option>
                        </ng-select>
                        <div class="field-help">Bij een error wordt de respons altijd bewaard. Bij Ja ook een goede respons; handig bij debuggen.</div>
                    </div>
                    <div class="info-block">
                        Tijdlijn bij een storing: de eerste mislukte poging zet de check direct op error. Daarna
                        {{ v.retries || 0 }}× opnieuw ({{ v.retry_delay | msReadable }} pauze + max. {{ v.timeout | msReadable }} wachten)
                        ≈ alle pogingen klaar na maximaal {{ timelineTotal() | msReadable }}.
                    </div>
                </div>
            </section>

            @for (range of ranges(); track range.nr) {
                <section class="form-section">
                    <div class="section-intro">
                        <div class="section-head">
                            <span class="section-icon"><i [class]="'fa-regular ' + range.icon"></i></span>
                            <h2>{{ range.title }}</h2>
                        </div>
                        <p>{{ range.description }}</p>
                    </div>
                    <div class="section-fields range">
                        <div class="range-bar">
                            <div class="error">Error</div>
                            <div class="warning">Waarschuwing</div>
                            <div class="ok">Goed</div>
                            <div class="warning">Waarschuwing</div>
                            <div class="error">Error</div>
                        </div>
                        <div class="range-fields">
                            @for (field of range.fields; track field.key) {
                                <div class="field">
                                    <label [for]="field.key">{{ field.label }}</label>
                                    <mat-form-field subscriptSizing="dynamic">
                                        <input [formControlName]="field.key" [id]="field.key" [name]="field.key" class="mono" matInput placeholder="—" type="number">
                                        <span class="unit" matTextSuffix>{{ range.unit }}</span>
                                    </mat-form-field>
                                    <div class="field-help">{{ field.help }}</div>
                                </div>
                            }
                        </div>
                    </div>
                </section>
            }
        </div>

        <div class="action-bar">
            <div class="action-bar-inner">
                <button (click)="cancel()" class="btn btn-outline-secondary" type="button">Annuleren</button>
                @if (Features.CheckpointsSave | hasFeature) {
                    <button (click)="save()" [disabled]="form()?.invalid || saving" class="btn btn-primary" type="submit">
                        Opslaan
                        @if (saving) {
                            <i class="fas fa-circle-notch fa-spin ml-2"></i>
                        }
                    </button>
                }
            </div>
        </div>
    }
</div>
